export const BOX_SHADOWS = {
  BOX_SHADOW1: "0px 2px 5px -1px rgb(0 0 0 / 15%)",
};
